import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import ActivityLoader from "../../Common/ActivityLoader";
import functions from "../../../util/functions";
import { numberFormat } from "../../../util/araknerdlib";

const PaymentTrends = ({ collectionData, discount, paidSum, currency }) => {
   const [chartData, setChartData] = useState(false);

  useEffect(()=>{

    if(functions.isObject(collectionData)){
    
                setChartData({
                  series: [collectionData.data[1]],
                  options: {
                    chart: {
                      type: "area", 
                      height: 200,
                      toolbar: {show: false},
                      animations: { enabled: true },
                      fontFamily: 'inherit',
                      zoom: { enabled: false }
                    },
                    stroke: {
                      curve: 'smooth',
                      width: 3,
                    },
                    dataLabels: { enabled: false, },
                    xaxis: {
                      categories: collectionData.class_names,
                      axisBorder: { show: false },
                      axisTicks: { show: false },
                      labels: {
                          style: { colors: '#94a3b8', fontSize: '11px' }
                      } 
                    },
                    yaxis: {
                      title: {
                        text: "Amount Collected", 
                      },
                      labels: {
                        formatter: (val) => functions.numberFormat(val),
                        style: { colors: '#94a3b8', fontSize: '11px' }
                      },
                    },
                    fill: {
                      type: "gradient", 
                      gradient: {
                        shadeIntensity: 1,
                        opacityFrom: 0.45,
                        opacityTo: 0.05,
                        stops: [0, 100],
                      },
                    },
                    colors: ['#4f46e5'],
                    grid: {
                      borderColor: '#f1f5f9',
                      strokeDashArray: 4,
                    },
                    tooltip: {
                      theme: 'light',
                      y: { formatter: (val) => `${currency} ${functions.numberFormat(val)}` }
                    },
                    legend: {
                      position: "top", 
                    },
                  },
                })
    }

  }, [collectionData])

  return (
    <div className="main-card mb-3 card border-0 shadow-sm" style={{ borderRadius: '16px' }}>
      <div className="card-body p-4">
        {/* Unified Header */}
        <div className="d-flex justify-content-between align-items-start mb-4">
          <div>
            <h6 className="text-uppercase text-muted fw-bold mb-1" style={{ fontSize: '11px', letterSpacing: '0.05rem' }}>
              Fees Collection Trend
            </h6>
            <div className="d-flex align-items-baseline">
              <h3 className="fw-extrabold mb-0" style={{ color: '#1e293b', fontSize: '1.35rem' }}>
                {paidSum ? numberFormat(paidSum) : '0'}
              </h3>
            </div>
          </div>
          
          <div className="text-end">
            <div className="badge bg-soft-danger text-danger p-2 px-3" style={{ borderRadius: '8px' }}>
                <i className="fa fa-minus-circle me-1"></i> 
                {currency} {numberFormat(discount)}
            </div>
            <div className="text-muted mt-1" style={{ fontSize: '10px', fontWeight: '600' }}>
                DISCOUNT EXCLUDED
            </div>
          </div>
        </div>

        {/* Chart Area */}
        <div className="mt-2" style={{ minHeight: '200px' }}>
          {chartData ? (
            <Chart
              options={chartData.options}
              series={chartData.series}
              type="area"
              height={220}
            />
          ) : (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '220px' }}>
                <ActivityLoader />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PaymentTrends;